import { useEffect } from "react";

const BASE = "Wostel Djerba";

export default function useTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} · ${BASE}` : `${BASE} · South Tunisia & Island of Djerba`;
  }, [title]);
}
